import { render, staticRenderFns } from "./insuranceDetails.vue?vue&type=template&id=ce5fca46&scoped=true&"
import script from "./insuranceDetails.vue?vue&type=script&lang=js&"
export * from "./insuranceDetails.vue?vue&type=script&lang=js&"
import style0 from "./insuranceDetails.vue?vue&type=style&index=0&id=ce5fca46&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce5fca46",
  null
  
)

export default component.exports